import api from "./client";

export interface TrialGeneratedImage {
  generatedImageIdx: number;
  imageUrl: string;
  categoryKey: string;
  sortOrder: number;
  s3Key?: string;
}

export type TrialJobStatus = "processing" | "completed" | "failed";
export type TrialOrderStatus =
  | "processing"
  | "completed"
  | "cancelled"
  | "failed";

export interface TrialOrder {
  orderIdx: number;
  status: TrialOrderStatus;
  generatedImages: TrialGeneratedImage[];
}

export interface TrialStatusResponse {
  available: boolean;
  trialOrder: TrialOrder | null;
}

export interface TrialGenerateResponse {
  orderIdx: number;
  jobIdx: number;
  status: "processing";
  message: string;
}

export interface TrialResultResponse {
  orderIdx: number;
  status: TrialJobStatus | "unknown";
  progress: number;
  generatedImages: TrialGeneratedImage[];
  errorMessage: string | null;
}

/** 체험 가능 여부 확인 */
export const getTrialStatus = (): Promise<TrialStatusResponse> =>
  api.get("/v1/trial/status").then((res) => res.data.data ?? res.data);

/** 무료 체험 생성 요청 */
export const generateTrial = (
  uploadIdxList: number[],
  categoryKey: string,
): Promise<TrialGenerateResponse> =>
  api
    .post("/v1/trial/generate", { uploadIdxList, categoryKey })
    .then((res) => res.data.data ?? res.data);

/** 무료 체험 생성 결과 조회 */
export const getTrialResult = (): Promise<TrialResultResponse> =>
  api.get("/v1/trial/result").then((res) => res.data.data ?? res.data);
